/* eslint-disable sonarjs/cognitive-complexity */
import React, { useMemo, useState } from 'react';
import { Formik } from 'formik';
import { PropTypes } from 'prop-types';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Affix, Col, Row } from 'antd';
import { Form } from 'formik-antd';
import { isEmpty } from 'lodash';
import { useDispatch } from 'react-redux';
import { Box, FormInput, CustomInput, Button } from 'atoms';
import { Debug } from '../Debug';
import { updateVendor } from 'store/vendorSlice';
import { ACL, EditModeBtn, ImageView } from 'components/common';
// import { useQuery } from 'hooks';
import FilesUploadS3 from 'components/common/FilesUploadS3';
import { CancelButton } from 'utils/commonStyled';
import { pdfimgfiletypetoShow, pdfimgformates } from 'utils';

const FormSchema = Yup.object({
	acc_number: Yup.string()
		.required()
		.min(6)
		.max(24)
		.label('Account Number')
		.matches(/^[0-9]*$/, 'Please enter valid Account Number'),
	ifsc_code: Yup.string()
		.required()
		.min(11)
		.max(11)
		.label('IFSC Code')
		.matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Please enter valid IFSC ode'),
	bank_name: Yup.string()
		.required()
		.min(4)
		.max(30)
		.label('Bank Name')
		.matches(/^[a-zA-Z0-9 ]*$/, 'Please enter valid Bank Name'),
	bank_city: Yup.string()
		.required()
		.label('Bank City')
		.matches(/^[a-zA-Z ]*$/, 'Please enter valid address'),
	bank_branch: Yup.string()
		.required()
		.min(5)
		.max(32)
		.label('Bank Branch')
		.matches(/^[a-zA-Z0-9 -.,&/()]*$/, 'Please enter valid Branch'),
});

export default function BankingDetailsForm({ isEditMode = false, formData = {}, otherFormsData }) {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	// const [query] = useQuery();
	const [filesList, setFilesList] = useState([]);
	const [editMode, setEditMode] = useState(false);

	const initialValues = useMemo(
		() => ({
			acc_number: formData?.acc_number || undefined,
			ifsc_code: formData?.ifsc_code || undefined,
			bank_name: formData?.bank_name || undefined,
			bank_city: formData?.bank_city || undefined,
			bank_branch: formData?.bank_branch || undefined,
		}),
		[formData]
	);

	const handleSubmit = (values, { setErrors, setSubmitting }) => {
		const payload = {
			...otherFormsData,
			banking_info: {
				...values,
				bank_doc: !isEmpty(filesList) ? filesList : undefined,
			},
		};

		if (isEditMode) {
			payload.update_type = 'vendor';
		} else {
			payload.create_type = 'vendor';
		}

		dispatch(
			updateVendor({
				req_data: payload,
				setErrors,
				isEditMode,
			})
		)
			.then((res) => {
				setSubmitting(false);
				console.log(res);
				window.location = `${window.origin}/vendors/${res.data.id}?tab=3`;
			})
			.catch(() => {
				setSubmitting(false);
			});
	};

	function handleFileUpload(files) {
		setFilesList(files);
	}
	function handleEdit() {
		setEditMode(!editMode);
	}

	return (
		<Formik
			initialValues={initialValues}
			validationSchema={FormSchema}
			onSubmit={handleSubmit}
			enableReinitialize
		>
			{() => (
				<>
					<ACL action="update" module="vendor">
						{isEditMode && <EditModeBtn handleEdit={handleEdit} />}
					</ACL>
					<Form className={editMode === false ? 'disabled-div' : ''}>
						{otherFormsData?.vendor_type === 'temporary' && (
							<Affix offsetTop={10}>
								<Box
									background="red"
									padding="5px"
									color="#fff"
									fontSize="20px"
									marginTop="6px"
								>
									{' '}
									Note: Please fill All section data if its temporary Vendor{' '}
								</Box>
							</Affix>
						)}

						<Box padding="1.5rem 2rem" background="#fff">
							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="acc_number" label="Account Number *">
										<CustomInput name="acc_number" />
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput name="ifsc_code" label="IFSC Code *">
										<CustomInput name="ifsc_code" maxLength={11} isCaps />
									</FormInput>
								</Col>
							</Row>
							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="bank_name" label="Bank Name *">
										<CustomInput name="bank_name" />
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput name="bank_city" label="Bank City *">
										<CustomInput name="bank_city" />
									</FormInput>
								</Col>
							</Row>
							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="bank_branch" label="Bank Branch *">
										<CustomInput name="bank_branch" />
									</FormInput>
								</Col>
							</Row>
						</Box>
						<Box border="1px solid #ccc" padding="34px">
							<FilesUploadS3
								entity="vendor"
								successCallBack={handleFileUpload}
								name="Bank document"
								size={5120000}
								fileformates={pdfimgformates}
								filetypetoShow={pdfimgfiletypetoShow}
							/>
							<Box backgroundColor="#fff" textAlign="right" padding="1.5rem"></Box>
							{filesList && (
								<ImageView
									entity="vendor"
									files={formData?.bank_doc}
									name="Bank Document"
								/>
							)}
						</Box>

						<Box backgroundColor="#f5f5f5" textAlign="right" padding="1.5rem">
							<CancelButton onClick={() => navigate('/vendor-list')} type="button">
								Cancel
							</CancelButton>
							<Button borderRadius="4px" backgroundColor="#18405d" type="submit">
								{isEditMode ? 'Update' : 'Submit'}
							</Button>
						</Box>
						<Debug />
					</Form>
				</>
			)}
		</Formik>
	);
}

BankingDetailsForm.propTypes = {
	isEditMode: PropTypes.bool,
	formData: PropTypes.object,
	otherFormsData: PropTypes.object,
};
